<template>
  <div class="mx-10 ma-5">
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <div>
      <v-card flat class="pa-5">
        <PageTitleWithSearch
          :title="'Products'"
          :btnName="'Add New Product'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/product/create'"
          :btnPermission="'product.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        />
        <DataTableWithPagination
          :headers="headers"
          :items="products"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="page = $event"
        >
          <template #row="{ item}">
            <tr :key="item.uuid" @click="goToGrnDetails(item)">
              <td class="text-left ">{{ item.product_code }}</td>
              <td class="text-left ">{{ item.product_category }}</td>
              <td class="text-left">{{ item.name }}</td>
              <td class="text-left">{{ item.status }}</td>
              <td class="text-center">
                <v-btn
                  v-if="hasPermission('product.edit')"
                  class="ma-1"
                  color="#FFE0B2"
                  :to="'/product/edit/' + item.uuid"
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  class="ma-1"
                  disabled
                  fab
                  x-small
                  style="box-shadow: none;"
                  ><v-icon small color="#FF9800">mdi-pencil</v-icon></v-btn
                >
                <v-btn
                  v-if="hasPermission('product.delete')"
                  color="#FFCDD2"
                  fab
                  x-small
                  style="box-shadow: none;"
                  @click.stop="dropProductConfirm(item.uuid)"
                >
                  <v-icon small color="#F44336">mdi-delete</v-icon>
                </v-btn>
                <v-btn v-else disabled fab x-small style="box-shadow: none;">
                  <v-icon small color="#FF9800">mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </DataTableWithPagination>
      </v-card>
    </div>
    <ConfirmModal
      :text="'Do you want to drop this product?'"
      :title="'Drop Product'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm"
      @confirm="confirm"
    />
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="snackbarColor"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import ConfirmModal from "@/components/shared/ConfirmModal";
import Snackbars from "@/components/shared/Snackbars";
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import { checkError } from "@/config/errors.js";
import { ProductService } from "../../services/product-service";
import Alert from "@/components/shared/Alert.vue";

export default {
  name: "ProductGrid",
  components: {
    PageTitleWithSearch,
    ConfirmModal,
    Snackbars,
    DataTableWithPagination,
    Alert,
  },
  data() {
    return {
      products: [],
      page: 1,
      search: "",
      loading: false,
      role: localStorage.getItem("role") || null,
      total: 0,
      totalProducts: 0,
      dropId: null,
      confirmOpen: false,
      errors: null,
      snackbar: false,
      successMsg: "",
      snackbarColor: "warning",
      headers: [
        { text: "Product Code", value: "product_code", align: "start" },
        { text: "Product Category", value: "product_category", align: "start" },
        { text: "Product Name", value: "name", align: "start" },
        { text: "Status", value: "status", align: "start" },
        { text: "Action", value: "actions", align: "center" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getProduct();
  },
  watch: {
    search(newSearch) {
      this.getProduct(newSearch);
    },
    page() {
      this.getProduct(this.search);
    },
  },
  methods: {
    async getProduct(search = "") {
      this.loading = true;
      try {
        const response = await ProductService.getProductList(search, this.page);
        this.products = response.data?.data || [];
        this.total = response.data?.meta?.last_page || 0;
        this.totalProducts = response.data?.meta?.total || 0;
        console.log("this.products : ", this.products);
      } catch (error) {
        this.products = [];
        this.total = 0;
        this.totalProducts = 0;
        console.error("Error fetching Products List:", error);
      } finally {
        this.loading = false;
      }
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    getStatusColor(status) {
      let bgColor = "";
      switch (true) {
        case status === "ACTIVE":
          bgColor = "#A5D6A7";
          break;
        default:
          bgColor = "#EF9A9A";
          break;
      }
      return bgColor;
    },
    searchChange(event) {
      this.search = event;
    },
    dropProductConfirm(uuid) {
      this.dropId = uuid;
      this.confirmOpen = true;
      console.log("1 - Drop product", uuid);
    },
    cancelConfirm() {
      this.confirmOpen = false;
      console.log("Cancel product");
    },
    confirm() {
      this.confirmOpen = false;
      this.dropProduct();
      console.log("2");
    },
    dropProduct() {
      if (this.dropId) {
        this.loading = true;
        ProductService.dropProduct(this.dropId)
          .then((response) => {
            if (response.data.message === "Product deleted successfully") {
              this.loading = false;
              this.getProduct(this.search);
              this.snackbarColor = "success";
              this.successMsg = "Product dropped successfully";
            }
            this.snackbar = true;
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response?.data?.error || "Unknown error";

            let errorOutput = checkError.errorFormatting(data);
            let errorsArray = [];
            if (Array.isArray(errorOutput)) {
              errorsArray = errorOutput.filter((e) => !!e && e.trim());
              if (errorsArray.length === 0) errorsArray = [data];
            } else if (errorOutput && errorOutput.trim()) {
              errorsArray = [errorOutput];
            } else {
              errorsArray = [data];
            }
            this.errors = errorsArray;
          });
      }
    },
    closeSnackbar() {
      this.snackbar = false;
    },

    onDismissed() {
      this.errors = null;
    },
  },
};
</script>
